// extracted by mini-css-extract-plugin
module.exports = {"btns_action":"SubsystemPopupMenuVars_btns_action__1Qp9z"};